import { Navigate, Outlet } from "react-router";
import { useAuth } from "../api/auth";
import { useEffect } from "react";

type ProtectedRouteProps = {
    isAllowed?: boolean;
    redirectPath?: string;
    children?: React.ReactNode;
};

export const ProtectedRoute = ({ isAllowed = true, redirectPath = "/", children }: ProtectedRouteProps) => {

    const { isloggedIn } = useAuth();

    if (!isloggedIn) {
        return <Navigate to={redirectPath} replace />;
    }

    return <>{children ? children : <Outlet />}</>;
};